import { fetchFirstUserInfo ,fetchInsertUserInfo  ,fetchConfirmExistPassword, fetchUpdateFirstUserInfo} from "@/api/api.user";

const userStoreModule = {
  state: {
    userInfo : [],
    userErrors : null
  },
  getters: {
  },
  mutations : {
    SET_USER(state, userInfo) {
      state.userInfo = userInfo;
      sessionStorage.setItem('loginUserData', JSON.stringify(userInfo.solutionMap["0000"]))
    },
    SET_USER_ERROR(state, error) {
      state.userErrors = error;
       kendo.alert(error);
    }
  },
  actions : {
    FETCH_USER(context) {
      return new Promise(resolve => {
        fetchFirstUserInfo()
          .then(response => {
            if (response.data.resultStatus.messageCode === "2000") {
              context.commit('SET_USER', response.data.resultData);
              resolve()
            } else {
              context.commit('SET_USER_ERROR', response.data.resultStatus.messageText);
              resolve()
            }
          })
          .catch(error => {
            console.log("==================== FETCH_USER error ====================");
            console.log(error);
            context.commit('SET_USER_ERROR', error);
          });
      })
    },
    FETCH_INSERT_USER_INFO(context, credentials) {
      return new Promise(resolve => {
        fetchInsertUserInfo(credentials)
        .then(response => {
          if(!response.data.resultStatus.messageCode === "2000") {
            context.commit('SET_USER_ERROR', response.data.resultStatus.messageText);
          }else{
            resolve(response.data);
          }
        })
        .catch(error => {
          console.log("==================== FETCH_INSERT_USER_INFO error ====================");
          console.log(error);
          context.commit('SET_USER_ERROR', error);
        });
    })
    },
    FETCH_CONFIRM_PASSWORD(context, credentials) {
      return new Promise(resolve => {
        fetchConfirmExistPassword(credentials)
          .then(response => {
            if (response.data.resultStatus.messageCode === "2000") {
              return resolve({
                valid: true
              });
            }else{
              return resolve({
                valid: false
              });
            }
          })
          .catch(error => {
            console.log("==================== error ====================");
            console.log(error);
            context.commit('SET_ERROR', error);
          });

      })
},
    FETCH_UPDATE_INFO(context, credentials) {
      return new Promise(resolve => {
        fetchUpdateFirstUserInfo(credentials)
          .then(response => {
            console.log()
          })
          .catch(error => {
            console.log("==================== error ====================");
            console.log(error);
            context.commit('SET_ERROR', error);
          });

      })
    }

  }
}

export default userStoreModule;
